import AdminHotelEdit from './admin-hotel-edit-component';
import AdminHotelEditService from './admin-hotel-edit-service';
import AdminHotelAmenitiesModule from './admin-hotel-amenities/admin-hotel-amenities-module';
import AdminHotelEditImagesModule from './admin-hotel-edit-images/admin-hotel-edit-images-module';
import AdminHotelEditBarModule from './admin-hotel-edit-bar/admin-hotel-edit-bar-module';

import './admin-hotel-edit.scss';

const MODULE_NAME = 'app.admin.hotel-edit';
const module = angular
    .module(MODULE_NAME, [
        'app.constants',
        AdminHotelEditBarModule,
        'App.admin.hotel-list',
        AdminHotelAmenitiesModule,
        AdminHotelEditImagesModule,
    ])
    .directive(AdminHotelEdit.DIRECTIVE_NAME, AdminHotelEdit)
    .service('adminHotelEditService', AdminHotelEditService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-edit/admin-hotel-edit-module.js